import { Button } from "@/components/ds/Button";

/**
 * L'écran qui remplace une page qui n'a pas pu s'ouvrir : un titre, une phrase,
 * et quand il y a quelque chose à refaire, le bouton qui le refait.
 *
 * Il était écrit cinq fois (page de dépôt indisponible ou inconnue, partage,
 * espace entreprise, espace école), et « Réessayer » y prenait trois formes : un
 * lien de 13px, un bouton d'icône sans icône, un bouton primaire pleine largeur.
 * C'est le dernier qui reste, partout. Le filet d'erreur (`ErrorBoundary`) garde
 * sa carte, mais le même bouton.
 */
export function PageMessage({
	title,
	body,
	retry,
}: {
	title: string;
	body?: string | null;
	retry?: { label: string; onClick: () => void };
}) {
	return (
		<main className="grid min-h-screen place-items-center bg-mg-page px-6">
			<div className="w-full max-w-sm text-center">
				<h1 className="t-h2 text-mg-heading">{title}</h1>
				{body ? <p className="t-body mt-3 text-mg-secondary">{body}</p> : null}
				{retry ? (
					<Button tone="primary" full className="mt-6" onClick={retry.onClick}>
						{retry.label}
					</Button>
				) : null}
			</div>
		</main>
	);
}
